import "babel-polyfill";
import { ConnectedRouter, connectRouter, routerMiddleware } from 'connected-react-router';
import "font-awesome/css/font-awesome.css";
import createHistory from 'history/createBrowserHistory';
import * as React from 'react';
import "react-datetime/css/react-datetime.css";
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createForms } from "react-redux-form";
import { Route, Switch, match } from 'react-router';
//import 'react-select/dist/react-select.css';
import { reducer as notificationsReducer } from 'reapop';
import { combineReducers } from "redux";
import thunk from 'redux-thunk';
import './configuration/styles';
import * as Deprecated_Configuration from './configuration';
import './css/weather-icons.min.css';
import { rootEpic } from './epics/';
import * as DocumentTitle from 'react-document-title';
import * as ReactGA from 'react-ga';
import Framework from "./components/Framework/Framework";
import Notifications from './components/Common/Notifications';
import * as Configuration from './components/Framework/configuration/index'

import { configureStore } from "./store/";
import admin, { AdminState } from "./reducers/admin.reducer";
import data, { DataState } from "./reducers/data.reducer";
import file, { FileState } from "./reducers/file.reducer";
import filter, { FilterState } from "./reducers/filter.reducer";
import map, { MapState } from "./reducers/map.reducer";
import preference, { PreferenceState } from "./reducers/preference.reducer";
import referenceData, { ReferenceDataState } from "./reducers/referenceData.reducer";
import survey, { SurveyState } from "./reducers/survey.reducer";
import user, { UserState } from "./reducers/user.reducer";
import userGroups, { UserGroupState } from "./reducers/userGroup.reducer";

var ChartDataLabels = require('../node_modules/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.js');

import ReactChartkick from 'react-chartkick';
import * as Chart from 'chart.js';
import summarydata, { SummaryDataState } from "./reducers/summaryData.reducer";
import template, { TemplateState } from "./reducers/template.reducer";

Chart.defaults.global.defaultFontColor = Configuration.AppConfig.chartsConfig.defaultFontColor;
Chart.defaults.global.defaultFontSize = Configuration.AppConfig.chartsConfig.defaultFontSize;

//Chart.plugins.unregister(ChartDataLabels);
ReactChartkick.addAdapter(Chart);


//import { geoLocationApi } from "./Common";
/*if (process.env.NODE_ENV !== 'production') {
    const {whyDidYouUpdate} = require('why-did-you-update')
    whyDidYouUpdate(React)
}*/
if (Deprecated_Configuration.custom.googleAnalyticsTrackingCode) {
    ReactGA.initialize(Deprecated_Configuration.custom.googleAnalyticsTrackingCode
    );
}

//var Loader = require('react-loaders').Loader;

export interface IAppState {
    admin: AdminState;
    data: DataState;
    file: FileState;
    filter: FilterState;
    map: MapState;
    preference: PreferenceState;
    referenceData: ReferenceDataState;
    user: UserState;
    userGroup: UserGroupState;
    summaryData: SummaryDataState;
    surveyState: SurveyState;
    template: TemplateState;
    forms: any;
}

interface IAppActions {

    navigate?: Function;
}

interface IAppProps {
    //user?: DashboardDtos.User;
    match?: match<any>
}

type AppProps = IAppProps & IAppActions;

export interface ITheme {
    classification: string;
    route: string;
    theme: string;
    setThemeContext: Function;
}

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

export const ThemeContext: React.Context<ITheme> = React.createContext(
    {
        classification: "",
        route: "",
        theme: "",
        setThemeContext: () => {}
    }
);

class App extends React.Component<AppProps, any> {
    constructor(props) {
        super(props);
    }


    render() {

        return (
            <>
                <Notifications />
                <DocumentTitle title={Configuration.AppConfig.defaultDocumentTitle}>
                    <ConnectedRouter history={history}>
                        <Switch>
                            <Route path="" component={Framework} />
                        </Switch>
                    </ConnectedRouter>
                </DocumentTitle>
            </>);
    }
}

// Build the middleware for intercepting and dispatching navigation actions
const historyMiddleware = routerMiddleware(history);

const reducer = connectRouter(history)(combineReducers({
    admin: admin,
    data: data,
    file: file,
    filter: filter,
    notifications: notificationsReducer(),
    referenceData: referenceData,
    summaryData: summarydata,
    surveyState: survey,
    template: template,
    user: user,
    userGroup: userGroups,
    ...createForms({
        preference: preference,
        map: map,
        surveyState: survey
    }),
}));

export const store = configureStore(reducer, rootEpic, thunk, historyMiddleware);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>, document.getElementById("app"));
